module.exports = __webpack_public_path__ + "img/PRprinting4.458708a8.png";